/* tslint:disable */
/* eslint-disable */
/**
 * True one Services API
 * True one service for form Builder
 *
 * The version of the OpenAPI document: 4.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from '../runtime';
import type { MeasurementSpec } from './MeasurementSpec';
import {
    MeasurementSpecFromJSON,
    MeasurementSpecFromJSONTyped,
    MeasurementSpecToJSON,
    MeasurementSpecToJSONTyped,
} from './MeasurementSpec';

/**
 * 
 * @export
 * @interface MachinePartType
 */
export interface MachinePartType {
    /**
     * 
     */
    id?: string;
    /**
     * 
     */
    type?: string;
    /**
     * 
     */
    name?: string;
    /**
     * 
     */
    description?: string;
    /**
     * 
     */
    partNumber?: string;
    /**
     * 
     */
    imageUrl?: string;
    /**
     * 
     */
    measurementSpecs?: Array<MeasurementSpec>;
    /**
     * 
     */
    createdAt?: Date;
    /**
     * 
     */
    updatedAt?: Date;
    /**
     * 
     */
    active?: boolean;
}

/**
 * Check if a given object implements the MachinePartType interface.
 */
export function instanceOfMachinePartType(value: object): value is MachinePartType {
    return true;
}

export function MachinePartTypeFromJSON(json: any): MachinePartType {
    return MachinePartTypeFromJSONTyped(json, false);
}

export function MachinePartTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): MachinePartType {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'type': json['type'] == null ? undefined : json['type'],
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'partNumber': json['partNumber'] == null ? undefined : json['partNumber'],
        'imageUrl': json['imageUrl'] == null ? undefined : json['imageUrl'],
        'measurementSpecs': json['measurementSpecs'] == null ? undefined : ((json['measurementSpecs'] as Array<any>).map(MeasurementSpecFromJSON)),
        'createdAt': json['createdAt'] == null ? undefined : (parseDateTime(json['createdAt'])),
        'updatedAt': json['updatedAt'] == null ? undefined : (parseDateTime(json['updatedAt'])),
        'active': json['active'] == null ? undefined : json['active'],
    };
}

export function MachinePartTypeToJSON(json: any): MachinePartType {
    return MachinePartTypeToJSONTyped(json, false);
}

export function MachinePartTypeToJSONTyped(value?: MachinePartType | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'type': value['type'],
        'name': value['name'],
        'description': value['description'],
        'partNumber': value['partNumber'],
        'imageUrl': value['imageUrl'],
        'measurementSpecs': value['measurementSpecs'] == null ? undefined : ((value['measurementSpecs'] as Array<any>).map(MeasurementSpecToJSON)),
        'createdAt': value['createdAt'] == null ? value['createdAt'] : serializeDateTime(value['createdAt']),
        'updatedAt': value['updatedAt'] == null ? value['updatedAt'] : serializeDateTime(value['updatedAt']),
        'active': value['active'],
    };
}

